<template>
  <div ref="transcriptContainer" class="transcript__container">
    <div
      v-for="cue in episodeTranscript"
      :key="`${cue.id}-cue`"
      :class="getClasses(cue.startTime, cue.endTime)"
      @click="handleCueClick(cue.startTime)"
    >
      <Anchor
        v-if="isCurrentTranscript(cue.startTime, cue.endTime)"
        :ref-name="`${cue.id}-transcript-anchor`"
        :scroll-into-view-block-offset="160"
        @scroll-request="handleScrollRequest"
      />
      <span>{{ cleanText(cue.text) }}</span>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { decodeHtmlEntities } from '@/lib/utils'

import Anchor from '@/components/common/Anchor/Anchor.vue'

export default {
  components: {
    Anchor
  },

  computed: {
    ...mapState('player', ['currentTime', 'transcript']),

    episodeTranscript () {
      return this.transcript
    }
  },

  methods: {
    ...mapActions('player', ['setSkipTo', 'setPlayerStatus']),

    isCurrentTranscript (startTime, endTime) {
      return this.currentTime >= startTime && this.currentTime < endTime
    },

    getClasses (startTime, endTime) {
      const isCurrentTranscript = this.isCurrentTranscript(startTime, endTime)
      const hasPlayed = this.currentTime >= endTime
      return ['transcript__cue', { 'transcript__cue-played': hasPlayed }, { 'transcript__cue-not-played': !hasPlayed && !isCurrentTranscript }]
    },

    handleScrollRequest ({ top, offset }) {
      const container = this.$refs.transcriptContainer
      const containerRect = container.getBoundingClientRect()

      const scrollTop = container.scrollTop
      const scrollTarget = top - containerRect.top + scrollTop - offset

      container.scrollTo({
        top: scrollTarget,
        behavior: 'smooth'
      })
    },

    handleCueClick (time) {
      this.setSkipTo(time)
      this.setPlayerStatus('playing')
    },

    cleanText (text) {
      return decodeHtmlEntities(text)
    }
  }
}
</script>

<style lang="scss" scoped>
.transcript {
  &__container {
    display: flex;
    flex-direction: column;
    gap: $gap * 1.25;
    height: 100%;
    overflow-y: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
    padding-bottom: 105px;
    padding-top: 136px;

    @include display-less(phablet) {
      padding-top: 0;
    }

    &::-webkit-scrollbar {
      display: none;
    }
  }

  &__cue {
    font-size: 40px;
    line-height: 120%;
    font-weight: 700;
    word-wrap: break-word;
    white-space: pre-line;
    cursor: pointer;

    @include display-less(phablet) {
      font-size: 24px;
    }

    &:hover {
      opacity: 100%;
      text-decoration: underline;
    }

    &-played {
      opacity: 80%;
    }

    &-not-played {
      opacity: 40%;
    }
  }
}
</style>
